// third-party
import { combineReducers } from 'redux';

// project-imports
import snackbar from './snackbar';

// import snackbar from './snackbar';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  snackbar
});

export default reducers;
